import { WidgetConfigWithLegends } from 'widgets/WidgetLegend/WidgetConfigWithLegends';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { BreaksRenderType } from 'utils/components/TimeSeriesChart/timebreaks';

export interface PortfolioReturnsWidgetLegends {
    hideTotal: boolean;
    hideBuy: boolean;
    hideSell: boolean;
    hideShort: boolean;
    hideIndex1: boolean;
    hideIndex2: boolean;
}

export interface PortfolioReturnsConfigurationState
    extends WidgetConfigWithHideableToolbar,
        WidgetConfigWithLegends<PortfolioReturnsWidgetLegends> {
    index1?: string;
    index2?: string;
    days?: number;
    showMarketSessionTimes: boolean;
    hideTitlePanel?: boolean;
    useAvgExecPrice?: boolean;
    /*
     * For IND2-2686: when true sell line is inverted and total line is hidden
     */
    invertSellLine?: boolean;
    breaks?: BreaksRenderType;
}

export const initialPortfolioReturnsConfigurationState: PortfolioReturnsConfigurationState =
    {
        days: 1,
        showMarketSessionTimes: true,
        hideTotal: false,
        hideBuy: false,
        hideSell: false,
        hideShort: false,
        hideIndex1: false,
        hideIndex2: false,
        hideTotalLegend: false,
        hideBuyLegend: false,
        hideSellLegend: false,
        hideShortLegend: false,
        hideIndex1Legend: false,
        hideIndex2Legend: false,
        hideToolbar: false,
    };
